module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
    }],
    staticClass: "icon__bg-circle",
    class: {
      'icon__bg-circle--active': _vm.isPrioritizerActive
    },
    attrs: {
      "content": _vm.$t('vue2.sub_scheduler.set_priorities')
    },
    on: {
      "click": function($event) {
        return _vm.setIsPrioritizerActive(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cog2"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInLeft"
    }
  }, [(_vm.isPrioritizerActive) ? _c('div', {
    staticClass: "sub-scheduler__filters__subzen__priorities"
  }, [_c('div', {
    staticClass: "sub-scheduler__filters__subzen__priorities__header"
  }, [_c('h3', [_vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler.set_priorities')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle sub-scheduler__filters__subzen__priorities__close",
    on: {
      "click": function($event) {
        return _vm.setIsPrioritizerActive(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    staticClass: "pad-10-bottom"
  }, [_c('draggable', {
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": "flip-list"
    }
  }, _vm._l((_vm.list), function(element, key) {
    return _c('div', {
      key: element[0],
      staticClass: "sub-scheduler__filters__subzen__priorities__priority"
    }, [_c('div', {
      staticClass: "sub-scheduler__filters__subzen__priorities__priority__number"
    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getItemTitle(element[0])))])])
  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "border-1-top sub-scheduler__unAvailableItems"
  }, _vm._l((_vm.unAvailableItems), function(item, key) {
    return _c('li', {
      staticClass: "sub-scheduler__filters__subzen__priorities__priority sub-scheduler__filters__subzen__priorities__priority--not-moveable"
    }, [_c('div', {
      staticClass: "sub-scheduler__filters__subzen__priorities__priority__number"
    }, [_vm._v(_vm._s(7 + key))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getItemTitle(item[0])))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sub-scheduler__filters__subzen__priorities__footer pad-10-bottom"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isPrioritizerActive = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary marg-10-left",
    class: {
      'bttn-primary--disabled': !_vm.isChangeHasBeenMade
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.save')) + "\n        ")])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69d40041!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/Scheduler/SchedulerPrioritizer.vue
// module id = 1697
// module chunks = 1